import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext } from "react";
import styled, { css } from "styled-components";
import { HighlightText } from "../../highlightText/HighlightText";
import { defaultControlSize } from "../../newCommon/ControlsCommon";
import { SelectDropdownOptions } from "../components/SelectDropdownOptions";
import { MultiSelectOption, UltraSelectOption } from "../components/SelectOption";
import { Placeholder } from "../components/Styled";
import { USelectContext } from "../context/context";
export const renderSingleOptionDefault = (props) => {
    return _jsx(CreateOption, { ...props });
};
const CreateOption = memo(({ option, size = defaultControlSize, active, hover, disabled, onClick, onMouseEnter, }) => {
    const { debounceSearch } = useContext(USelectContext);
    return (_jsx(StyledSingleOption, { "$size": size, "$active": active, "$hover": hover, "$disabled": disabled, role: "option", "data-value": option.value, onClick: onClick, onMouseEnter: onMouseEnter, children: _jsx(HighlightText, { highlight: debounceSearch, children: option.label }) }));
});
const StyledSingleOption = styled(UltraSelectOption) `
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  ${(p) => !p.$hover &&
    css `
      background-color: ${(p) => p.theme.systemColors.grey50};
    `};
`;
export const renderOptionDefault = (props) => {
    return _jsx(MultiSelectOption, { ...props });
};
export const renderOptionsDefault = (props) => {
    return _jsx(SelectDropdownOptions, { ...props });
};
export const renderValueDefault = (props) => (_jsx(MultiSelectCountedValue, { value: props.value, placeholder: props.placeholder, error: props.error }));
const MultiSelectCountedValue = memo(({ value, placeholder, error }) => {
    return value?.length ? (_jsxs("span", { children: [value.length, " selected"] })) : (_jsx(Placeholder, { "$error": error, children: placeholder }));
});
export const defaultDropdownHeight = 320;
export const defaultItemSize = 40;
